import { FrameName } from "../config";
import AbstractSalvageableFightableEnemyTileEntity from "./AbstractSalvageableFightableEnemyTileEntity";

class ShallowSeaRaidersFlagshipSalvageableTileEntity extends AbstractSalvageableFightableEnemyTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_RAIDERS_FLAGSHIP;
}

export default ShallowSeaRaidersFlagshipSalvageableTileEntity;
